// libraries
import { useSelector } from 'react-redux';

// hooks
import useWebSocketGeoref from './useWebSocketGeoref';
import useCustomWebSocket from './useCustomWebSocket';
import { HermesMessageMX } from '../interfaces/interfaces';

// selectors
import { getSelectedTask } from '@domains/documents-review/store/slices/document-review-slice';
import { getHermesDataBody } from '../slices/hermesData.slice';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

interface UseBusinessTypeWebSocketProps {
  whenSuccessGeoref: () => void;
}

const useBusinessTypeWebSocket = ({
  whenSuccessGeoref,
}: UseBusinessTypeWebSocketProps) => {
  const selectedTask = useSelector(getSelectedTask);
  const bodyForHermes = useSelector(getHermesDataBody);
  const country = useSelector(getCountry);

  // Obtener business_type de la tarea seleccionada
  const businessType = selectedTask?.business_type as
    | 'committee'
    | 'real_estate';

  // Hook para el flujo normal (committee)
  useWebSocketGeoref({
    whenSuccessGeoref,
  });

  // Hook para el flujo directo (real_estate)
  const { sendRealEstatePayload } = useCustomWebSocket({
    whenSuccessGeoref,
  });

  const sendRealEstateData = () => {
    if (!bodyForHermes) {
      console.error('No hay datos del formulario disponibles');
      return;
    }

    // Construir el payload para real_estate usando los datos del formulario
    const realEstatePayload: HermesMessageMX = {
      country: country || 'MX',
      agent: bodyForHermes.agent || selectedTask?.agent || '',
      area: bodyForHermes.area || 0,
      room_num: bodyForHermes.room_num || 0,
      garage: bodyForHermes.garage || 0,
      elevator: bodyForHermes.elevator || 0,
      bath: bodyForHermes.bath || 0,
      half_bathroom: bodyForHermes.half_bathroom || 0,
      latitude: bodyForHermes.latitude || 0,
      longitude: bodyForHermes.longitude || 0,
      years_old: bodyForHermes.years_old || 0,
      floor_num: bodyForHermes.floor_num || 0,
      land_area: bodyForHermes.land_area || 0,
      address: bodyForHermes.address || '',
      property_type_id: bodyForHermes.property_type_id || 0,
      price_type: bodyForHermes.price_type || 'initial_pricing',
      validations: true,
      exterior_number: (bodyForHermes as any).exterior_number || '',
      mex_state_id: (bodyForHermes as any).mex_state_id || '',
      zip_code: (bodyForHermes as any).zip_code || '',
      deal_id: Number(bodyForHermes.property_deal_id || selectedTask?.nid || 0),
      hubspot_ignore: ['dealname'],
    };

    console.log(
      'Enviando payload directo para real_estate:',
      realEstatePayload
    );
    sendRealEstatePayload(realEstatePayload);
  };

  const handleWebSocketSend = () => {
    if (businessType === 'real_estate') {
      sendRealEstateData();
    }
  };

  return {
    businessType,
    handleWebSocketSend,
    sendRealEstateData,
  };
};

export default useBusinessTypeWebSocket;
